"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Drawer = exports.DragHandle = exports.Dialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog)((param)=>{
    let { theme } = param;
    return {
        ["& .".concat(_components.dialogClasses.dialogGrid)]: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'block',
                height: '100%',
                margin: theme.spacing(6),
                maxHeight: 'min(calc(100vh - 60px), 800px)',
                maxWidth: 1350,
                position: 'relative',
                width: '100%'
            }
        }
    };
});
const Drawer = exports.Drawer = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.spacing(2, 2, 0, 0),
        bottom: 0,
        height: '46%',
        left: 0,
        maxHeight: "".concat(_constants.DRAWER_MAX_HEIGHT_PERCENTAGE, "%"),
        minHeight: "".concat(_constants.DRAWER_MIN_HEIGHT_PERCENTAGE, "%"),
        position: 'fixed',
        transition: 'height 0.3s',
        width: '100%',
        zIndex: 1301,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    };
});
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            position: 'relative'
        }
    };
});
const DragHandle = exports.DragHandle = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        cursor: 'grab',
        padding: theme.spacing(3, 0),
        width: '100%',
        '&:before': {
            backgroundColor: theme.palette.grey[200],
            borderRadius: theme.spacing(1),
            content: '""',
            display: 'block',
            height: 4,
            margin: theme.spacing(0, 'auto'),
            width: 60
        }
    };
});
